import Repository from "../Repository";

const resource = "/bo/devices";
export default {
  /**
   * Get all devices dropdowns
   */
  getDropdowns(family) {
    return Repository.get(`/bo/parameter/devices?family=${family}`);
  },

  /**
   * Get all devices
   */
  get() {
    return Repository.get(`${resource}`);
  },

  /**
   * Create a device
   */
  create(payload) {
    return Repository.post(`${resource}`, payload);
  },

  /**
   * Get a device
   */
  getDevice(deviceId) {
    return Repository.get(`${resource}/${deviceId}`);
  },

  /**
   * Update a bracket
   */
  updateDevice(deviceId, payload) {
    return Repository.put(`${resource}/${deviceId}`, payload);
  },

  /**
   * Delete a bracket
   */
  deleteDevice(deviceId) {
    return Repository.delete(`${resource}/${deviceId}`);
  }
};
